import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import GroupsIcon from '@mui/icons-material/Groups'
import KingBedIcon from '@mui/icons-material/KingBed'
import RestaurantIcon from '@mui/icons-material/Restaurant'
import LocalActivityIcon from '@mui/icons-material/LocalActivity'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber'
import NewspaperIcon from '@mui/icons-material/Newspaper'
import HandshakeIcon from '@mui/icons-material/Handshake'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import IconButtonOutlined from '../../../root/components/IconButtonOutlined'

export default function ViewButtonGroup() {
  const { t } = useTranslation('admin')
  const { eventId, optionId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const ResponsiveButton = isMobile ? IconButtonOutlined : Button

  return (
    <Stack direction="row" gap="0.5rem" alignSelf={'end'} flexWrap={'wrap'} justifyContent="end">
      <Stack direction="row" gap="0.5rem" justifyContent="end">
        <ResponsiveButton
          color="primary"
          startIcon={<ConfirmationNumberIcon />}
          onClick={() => {
            navigate(`/admin/details/${eventId}/options`)
          }}
          disabled={location.pathname.includes('options') && optionId === undefined}
        >
          {isMobile ? <ConfirmationNumberIcon /> : t('Options')}
        </ResponsiveButton>
        <ResponsiveButton
          color="primary"
          startIcon={<GroupsIcon />}
          onClick={() => {
            navigate(`/admin/details/${eventId}/participants`)
          }}
          disabled={location.pathname.includes('participants')}
        >
          {isMobile ? <GroupsIcon /> : t('Participants')}
        </ResponsiveButton>
        <ResponsiveButton
          color="primary"
          startIcon={<LocalActivityIcon />}
          onClick={e => {
            e.stopPropagation()
            navigate(`/admin/details/${eventId}/contributors`)
          }}
          disabled={location.pathname.includes('contributors')}
        >
          {isMobile ? <LocalActivityIcon /> : t('Contributeurs')}
        </ResponsiveButton>
        <ResponsiveButton
          variant="outlined"
          color="primary"
          startIcon={<NewspaperIcon />}
          onClick={e => {
            e.stopPropagation()
            navigate(`/admin/details/${eventId}/abstracts`)
          }}
          disabled={location.pathname.includes('abstracts') && optionId === undefined}
        >
          {isMobile ? <NewspaperIcon /> : t('Résumés')}
        </ResponsiveButton>
        <ResponsiveButton
          variant="outlined"
          color="primary"
          startIcon={<HandshakeIcon />}
          onClick={e => {
            e.stopPropagation()
            navigate(`/admin/details/${eventId}/sponsorship`)
          }}
          disabled={location.pathname.includes('sponsorship')}
        >
          {isMobile ? <HandshakeIcon /> : t('P. charge')}
        </ResponsiveButton>
      </Stack>
      <Stack direction="row" gap="0.5rem" justifyContent="end">
        <ResponsiveButton
          color="primary"
          startIcon={<KingBedIcon />}
          onClick={() => {
            navigate(`/admin/details/${eventId}/hotels`)
          }}
          disabled={location.pathname.includes('hotels')}
        >
          {isMobile ? <KingBedIcon /> : t('Hôtels')}
        </ResponsiveButton>
        <ResponsiveButton
          color="primary"
          startIcon={<RestaurantIcon />}
          onClick={() => {
            navigate(`/admin/details/${eventId}/meals`)
          }}
          disabled={location.pathname.includes('meals')}
        >
          {isMobile ? <RestaurantIcon /> : t('Repas')}
        </ResponsiveButton>
        <ResponsiveButton
          color="primary"
          startIcon={<CalendarMonthIcon />}
          onClick={() => {
            navigate(`/admin/details/${eventId}/subevents`)
          }}
          disabled={location.pathname.includes('subevents')}
        >
          {isMobile ? <CalendarMonthIcon /> : t('Interventions')}
        </ResponsiveButton>
      </Stack>
    </Stack>
  )
}
